import Image from 'next/image';
import Link from 'next/link';

interface ChannelCardType {
  iconUrl: string;
  name: string;
  description: string;
  href: string;
}

const ChannelCard = ({ iconUrl, name, description, href }: ChannelCardType) => {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="block rounded-2xl border-2 border-pp-green-primary bg-white p-6 shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
    >
      <div className="mx-auto mb-4 flex size-16 items-center justify-center overflow-hidden rounded-full bg-gray-100 shadow-md">
        <Image
          src={iconUrl}
          alt={`${name}のアイコン`}
          width={64}
          height={64}
          className="size-full object-cover"
        />
      </div>
      <h3 className="mb-3 text-center text-xl font-bold text-pp-green-primary">
        {name}
      </h3>
      <p className="text-center text-sm leading-relaxed text-pp-text-secondary">
        {description}
      </p>
    </Link>
  );
};

const ChannelsSection = () => {
  const channels: ChannelCardType[] = [
    {
      iconUrl:
        'https://assets.postprime.com/images/d28d6c50-b06c-4b36-bbf0-b7025c7b3889.jpg',
      name: '米国株',
      description: '月～金曜日、毎日22時25分よりLIVE解説！',
      href: 'https://postprime.com/PostPrimeUS',
    },
    {
      iconUrl:
        'https://assets.postprime.com/images/d7d5f4f7-20f6-40b2-a61f-779072bdc834.jpg',
      name: '日本株',
      description: '月～金曜日、毎日20時30分よりLIVE解説！',
      href: 'https://postprime.com/PostPrimeJP',
    },
    {
      iconUrl:
        'https://assets.postprime.com/images/79aaaef3-0e7b-4dc2-8f01-124dd5b91763.jpg',
      name: '暗号資産',
      description: '月～金曜日、毎日22時よりLIVE解説！',
      href: 'https://postprime.com/crypto',
    },
    {
      iconUrl:
        'https://assets.postprime.com/images/794c7972-1287-4a41-bf69-214a5ddbef70.jpg',
      name: '商品コモディティ',
      description: '月～金曜日、毎日21時よりLIVE解説！',
      href: 'https://postprime.com/cmdty',
    },
  ];

  return (
    <section className="w-full bg-pp-bg-secondary px-6 py-20">
      <div className="mx-auto max-w-6xl">
        <h2 className="mb-4 text-center text-3xl font-bold text-pp-text-primary md:text-4xl">
          PostPrime専門チャンネル
        </h2>
        <p className="mb-8 text-center text-base text-pp-text-secondary md:text-lg">
          PostPrimeが運営する専門チャンネルで最新の市場情報をお届けします
        </p>

        {/* Channels Banner Image */}
        <div className="mx-auto mb-12 max-w-5xl">
          <div className="relative h-[300px] overflow-hidden rounded-2xl shadow-md md:h-[360px]">
            <Image
              src="/images/about/about-creator-img.jpg"
              alt="PostPrime専門チャンネル"
              fill
              className="object-cover"
            />
          </div>
        </div>

        {/* Channel Cards */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {channels.map((channel, index) => (
            <ChannelCard
              key={index}
              iconUrl={channel.iconUrl}
              name={channel.name}
              description={channel.description}
              href={channel.href}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChannelsSection;
